<template>
    <div class="app">
        <div class="box">
            <div class="top">
                <dv-border-box-12>
                    <dv-decoration-7 style="width:100%;height:30px;">来访记录</dv-decoration-7>
                    <div class="title">今日来访人数{{total}}人</div>
                    <dv-scroll-board :config="config" style="width:100%;height:200px" />
                </dv-border-box-12>
            </div>
            <div class="center">
                <dv-border-box-13 style="width:100%;height:300px;">
                    <div class="top">
                        <div class="zuo">
                            <ul>
                                <li>每日陪餐</li>
                                <li>领导陪餐</li>
                                <li>{{leader.status_name}}</li>
                            </ul>
                        </div>
                        <div class="you">
                            <ul>
                                <li>就餐情况</li>
                                <li v-for="(item,index) in leader.list" :key="index">
                                    <span style="float:left;margin-left:10%">{{item.name}}</span>
                                    <span style="float:right;margin-right: 15%;">{{item.value}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="foot">
                        <div class="zuo">
                            <ul>
                                <li>家委会陪餐</li>
                                <li>{{family.status_name}}</li>
                            </ul>
                        </div>
                        <div class="you">
                            <ul>
                                <li>就餐情况</li>
                                <li v-for="(item,index) in family.list" :key="index">
                                    <span style="float:left;margin-left:10%">{{item.name}}</span>
                                    <span style="float:right;margin-right: 15%;">{{item.value}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </dv-border-box-13>
            </div>
            <div class="xia">
                <dv-border-box-11 title="值班打卡" style="width:100%;height:250px;">
                    <div class="tit">
                        <span>值班领导：{{duty.leader_name}}</span>
                        <span>值班组长：{{duty.group_name}}</span>
                    </div>
                    <dv-scroll-board :config="configs" style="width:100%;height:150px" />
                </dv-border-box-11>
            </div>
        </div>
    </div>
</template>

<script>
import { dataBoardVisit } from "@/api/index";
export default {
    data() {
        return {
            tableData: [],
            total: '',
            family: {
                list: [],
                status_name: '',
            },
            leader: {
                list: [],
                status_name: '',
            },
            duty: {
                group_name: '',
                leader_name: '',
                list: [],
            },
            config: {
                data: [],
                waitTime: 4000,
                rowNum: 5,
                carousel: 'page',
                oddRowBGC: '',
                evenRowBGC: '',
                headerBGC: '',
                header: ['姓名', '来访对象', '来访事由',],
                align: 'center',
            },
            configs: {
                data: [],
                waitTime: 4000,
                rowNum: 3,
                carousel: 'page',
                oddRowBGC: '',
                evenRowBGC: '',
                headerBGC: '',
                header: ['序号', '岗点', '姓名', '打卡次数'],
                columnWidth: [60, 180, 90, 150],
                align: 'center',
            }
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        async getList() {
            const res = await this.axios.post(dataBoardVisit);
            if (res.data.code == 1) {
                this.tableData = res.data.data.visit.list;
                this.total = res.data.data.visit.total;
                this.family = res.data.data.meal.family;
                this.leader = res.data.data.meal.leader;
                this.duty = res.data.data.duty;
                let arr = [];
                this.tableData.forEach(e => {
                    arr.push([`${e.name}`, `${e.visitobject}`, `${e.reason}`,])
                })
                this.config.data = arr;
                this.config = { ...this.config };
                let arrs = [];
                this.duty.list.forEach(e => {
                    arrs.push([`${e.serial}`, `${e.station_name}`, `${e.user_name}`, `${e.total}次`])
                })
                this.configs.data = arrs;
                this.configs = { ...this.configs };
            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error'
                });
            }
        },
    },
}
</script>

<style lang='scss' scoped>
.app {
    width: 100%;
    height: 100%;
    .box {
        width: 100%;
        height: 100%;
        .chart {
            width: 100%;
            height: 100px;
        }
        .title {
            color: #fff;
            font-size: 14px;
        }
        .dv-decoration-7 {
            color: #fff;
            font-size: 14px;
        }
        .table {
            width: 100%;
            height: 60%;
            color: #fff;
            /deep/ .row-item {
                height: 60px !important;
                line-height: normal !important;
            }
            /deep/ .ceil {
                display: flex;
                width: 100% !important;
                /deep/ .left {
                    flex: 1;
                    width: 30%;
                    height: 100%;
                }
                /deep/ .right {
                    flex: 1;
                    height: 100%;
                    text-align: center;
                }
            }
        }
        .center {
            display: flex;
            flex-direction: row-reverse;
            .top {
                flex: 1;
                width: 100%;
                height: 50%;
                display: flex;
                flex-direction: row;
                .zuo {
                    flex: 1;
                    width: 40%;
                    height: 100%;
                    display: inline-block;
                    margin-top: 45px;
                    margin-left: -30px;
                    ul {
                        color: #fff;
                        font-size: 16px;
                        li {
                            margin-bottom: 5px;
                        }
                    }
                }
                .you {
                    flex: 1;
                    width: 40%;
                    height: 100%;
                    display: inline-block;
                    margin-top: 45px;
                    margin-left: -30px;
                    ul {
                        color: #fff;
                        font-size: 14px;
                        li {
                            margin-bottom: 5px;
                        }
                    }
                }
            }
            .foot {
                flex: 1;
                width: 100%;
                height: 50%;
                display: flex;
                flex-direction: row;
                .zuo {
                    flex: 1;
                    width: 40%;
                    height: 100%;
                    display: inline-block;
                    margin-top: 20px;
                    margin-left: -30px;
                    ul {
                        color: #fff;
                        font-size: 16px;
                        li {
                            margin-bottom: 5px;
                        }
                        li:first-child {
                            font-weight: bold;
                        }
                    }
                }
                .you {
                    flex: 1;
                    width: 40%;
                    height: 100%;
                    display: inline-block;
                    margin-top: 20px;
                    margin-left: -30px;
                    ul {
                        color: #fff;
                        font-size: 14px;
                        li {
                            margin-bottom: 5px;
                        }
                    }
                }
            }
        }
        .xia {
            .tit {
                color: #fff;
                padding-top: 70px;
                span:first-child {
                    margin-right: 5px;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/dataBoard/visitRecord.vue